import { SVG_TYPE } from 'Shared/enums';

export const CATEGORY_GROUPS = {
  motor: ['AM', 'A1', 'A2', 'A'],
  car: ['B', 'B1', 'B+E'],
  heavy: ['C1', 'C', 'D1', 'D', 'C1+E, C+E, D1+E, D+E'],
  other: ['T', 'Tramwaj'],
};

export const mapCategoriesByLabel = (categories) => {
  const byLabel = new Map(categories.map((item) => [item.label, item]));
  const pick = (labels) => labels.map((label) => byLabel.get(label)).filter(Boolean);

  return [pick(CATEGORY_GROUPS.motor), pick(CATEGORY_GROUPS.car), pick(CATEGORY_GROUPS.heavy), pick(CATEGORY_GROUPS.other)];
};

export const getCategoryIconType = (label: string) => {
  const firstChar = label?.trim()?.charAt(0)?.toUpperCase();
  switch (firstChar) {
    case 'A':
      return SVG_TYPE.MOTOR;
    case 'B':
      return SVG_TYPE.CAR;
    case 'C':
      return SVG_TYPE.DELIVERY_TRUCK;
    case 'D':
      return SVG_TYPE.BUS;
    case 'T':
      return SVG_TYPE.TRAIN;
    default:
      return SVG_TYPE.CHEVRON_RIGHT;
  }
};
